import { useNavigate } from "react-router-dom";
import imgWhiteLogo1 from "../assets/2ccda97ecaa4b401fe79d7f0575e654788a45c27.png";

export default function StayInTouchThankYouPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-[#00499d] flex flex-col text-white">
      <header className="w-full border-b border-white/15 bg-[#00499d]/80 backdrop-blur">
        <div className="mx-auto flex max-w-[1100px] items-center justify-between px-4 py-4">
          <button onClick={() => navigate("/")} className="flex items-center gap-2 text-white hover:opacity-80">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            Home
          </button>
          <div className="flex items-center gap-3">
            <img src={imgWhiteLogo1} alt="Project Ontario" className="h-8 w-8" />
            <div className="font-black leading-5 tracking-tight">
              <div>PROJECT</div>
              <div>ONTARIO</div>
            </div>
          </div>
          <div className="w-16" aria-hidden />
        </div>
      </header>

      <main className="flex-1 px-4 py-10 md:py-16">
        <div className="mx-auto flex w-full max-w-[1100px] flex-col gap-6 md:gap-10">
          <div className="relative overflow-hidden rounded-3xl border border-white/15 bg-white/10 p-6 shadow-2xl sm:p-8 md:p-10">
            <div
              className="absolute inset-0 -z-10 opacity-60"
              style={{
                background:
                  "radial-gradient(120% 120% at 20% 20%, rgba(255,255,255,0.14), transparent 40%), radial-gradient(80% 80% at 80% 10%, rgba(255,255,255,0.08), transparent 45%)",
              }}
            />
            <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
              <div className="flex flex-col items-center gap-4 text-center md:flex-row md:items-start md:text-left">
                <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white text-[#00499d]">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                </div>
                <div className="space-y-2">
                  <p className="text-sm uppercase tracking-[0.2em] text-white/70">Thank you</p>
                  <h1 className="text-3xl font-black leading-tight md:text-4xl">We'll keep you posted by email</h1>
                  <p className="max-w-2xl text-base text-white/80 md:text-lg">
                    Your support fuels Project Ontario. Expect concise updates, invitations, and ways to make a difference.
                    You can unsubscribe at any time.
                  </p>
                </div>
              </div>
              <button
                onClick={() => navigate("/survey")}
                className="w-full rounded-full bg-white px-5 py-3 text-center text-sm font-semibold text-[#00499d] transition hover:scale-[1.02] hover:shadow-lg md:w-auto"
              >
                Take the survey
              </button>
            </div>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/5 p-5 text-center text-sm text-white/80 sm:text-base sm:text-left">
            Add <span className="font-semibold text-white">info@projectontario.ca</span> to your contacts so our emails don't
            get lost in spam.
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <button
              onClick={() => navigate("/")}
              className="w-full inline-flex items-center justify-center rounded-full bg-white px-5 py-3 text-sm font-semibold text-[#00499d] transition hover:scale-[1.02] hover:shadow-lg sm:w-auto"
            >
              Return to the homepage
            </button>
            <a
              href="/#events"
              className="w-full inline-flex items-center justify-center rounded-full border border-white/50 px-5 py-3 text-sm font-semibold text-white transition hover:border-white hover:bg-white/10 sm:w-auto"
            >
              View upcoming events
            </a>
            <a
              href="/donate"
              className="w-full inline-flex items-center justify-center rounded-full border border-white/20 bg-white/10 px-5 py-3 text-sm font-semibold text-white transition hover:border-white/50 hover:bg-white/15 sm:w-auto"
            >
              Support the mission
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
